export default __webpack_public_path__ + "static/media/payment-auth-sk-light.21cdc583.png";